import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { DateUtilities, isDefined } from '@evorait/pace-core';

@Pipe({
    name: 'formatSapValue',
})
export class FormatSapValuePipe implements PipeTransform {
    public transform(value: string | number | null | undefined): string {
        if (!isDefined(value) || value === '') {
            return '';
        }

        // The trimmed value.
        const trimmedValue = `${value}`.trim();

        // Case 1: HHMMSS → HH:MM:SS
        if (/^\d{6}$/.test(trimmedValue)) {
            const parsed = moment(trimmedValue, 'HHmmss', true);
            if (parsed.isValid()) {
                return parsed.format('HH:mm:ss');
            }

            return trimmedValue; // fallback when invalid
        }

        // Case 2: SAP Date /Date(12345(+0200))/
        const timestamp = FormatSapValuePipe.extractTimestampFromSapDate(trimmedValue);
        if (timestamp !== null && !Number.isNaN(timestamp)) {
            const date = moment(timestamp);
            if (date.isValid()) {
                return DateUtilities.formatDate(date);
            }
            return trimmedValue;
        }

        // Return the original value if it doesn't match any known SAP format
        return trimmedValue;
    }

    private static extractTimestampFromSapDate(value: string): number | null {
        const match = value.match(/^\/Date\((\d+)(?:[+-]\d{4})?\)\/$/i);
        return match ? parseInt(match[1], 10) : null;
    }
}
